import type { Stylable } from '@core/utils/types'
import { cn } from 'cn'
import type { ElementType } from 'react'

export type IconCircleProps = Stylable & {
  icon: ElementType
}

export const IconCircle = ({ icon: Icon, className }: IconCircleProps) => (
  <span
    className={cn(
      'flex aspect-square size-6 shrink-0 items-center justify-center rounded-full bg-muted p-1 text-foreground',
      className
    )}
  >
    <Icon className='size-full' />
  </span>
)
